<template>
  <transition name="modal" appear>
    <Modal @close="handleCloseErrorModal" v-if="isErrorModalOpened" :is-custom-modal-body="isMsgInvalidQrCpm">
      <template #headline>
        <i class="icon icon-attention modal-header-icon"></i>
        {{ modalTitle || "入力内容のご確認" }}
      </template>
      <template #body>
        <div class="modal-error" :class="{ 'pl-15 pr-15': modalTitle }">
          <p
            v-for="(error, index) in commonErrors" :key="index"
            class="modal-error-msg"
            :class="{ 'custom-modal-error': modalTitle, 'ta-l': isTextLeft }"
          >
            {{ error }}
          </p>
        </div>
      </template>
      <template #footer>
        <button class="btn btn-rd btn-sm btn-bd-gray" :class="{ 'fz-16': modalTitle && isUseTicketFlag, 'custom-delete': isModalTitleCenter }" type="button" @click="closeErrorModal">閉じる</button>
      </template>
    </Modal>
  </transition>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Modal from '@/components/Modal.vue';
import { MESSAGE_MAP } from '@/config/message';

const store = useStore();
const route = useRoute();
const router = useRouter();

const isErrorModalOpened = computed(() => store.getters['common/isErrorModalOpened']);
const modalBackToRoute = computed(() => store.getters['common/modalBackToRoute']);
const commonErrors = computed(() => store.getters['common/errors']);
const modalTitle = computed(() => store.getters['common/modalTitle']);
const isChildEventUseTicketFlag = computed(() => store.getters['event/isChildEventUseTicketFlag']);
const isUseTicketFlag = computed(() => store.getters['event/isUseTicketFlag'] && isChildEventUseTicketFlag.value);
const backRouteName = computed(() => store.getters['common/backRouteName']);
const notClickOutside = computed(() => store.getters['common/notClickOutside']);
const isTextLeft = computed(() => modalTitle.value && ((!isUseTicketFlag.value && !isModalTitleCenter.value) || modalTitle.value === '予期せぬエラーが発生しました'));
const isModalTitleCenter = computed(() => ['銀行口座情報登録のご確認'].includes(modalTitle.value));
const notBackToCharge = computed(() => JSON.parse(sessionStorage.getItem('notBackToCharge')));
const isMsgInvalidQrCpm = computed(() => route.name === 'EntryOptionalQR');

const handleCloseErrorModal = () => {
  if (notClickOutside.value) return;
  closeErrorModal();
};
const closeErrorModal = async () => {
  const isChargeProcessing = route.name === 'ChargeProcessing' && route.query?.AccessID;
  if (backRouteName.value) {
    const isLoginPage = backRouteName.value === 'Login';
    if (isLoginPage) store.dispatch('auth/resetAuth');
    await router.push({ name: isLoginPage ? 'Login' : backRouteName.value });
    if ((route.name.includes('Entry') || !backRouteName.value?.includes('Entry')) && !isLoginPage) {
      window.location.reload();
    }
  } else if (isChargeProcessing || (['Credit', 'CreditBank'].includes(route.name) && !notBackToCharge.value)) {
    sessionStorage.removeItem('notBackToCharge');
    await router.push({ name: 'Charge', query: isChargeProcessing ? { backToHome: true } : {} });
  } else if (modalBackToRoute.value) {
    if (route.name === modalBackToRoute.value) {
      window.location.reload();
      return;
    } else {
      if (commonErrors.value[0].includes(MESSAGE_MAP.paymentTimeout)) {
        const targetRoute = modalBackToRoute.value;
        await store.dispatch('common/setModalBackToRoute', null);
        await router.replace({ name: targetRoute, query: { backToHome: true } });
        window.location.reload();
        return;
      } else {
        await router.push({ name: modalBackToRoute.value });
        await store.dispatch('common/setModalBackToRoute', null);
      }
    }
  }
  store.dispatch('common/openErrorModal', false);
  store.dispatch('common/setErrors', []);
  store.dispatch('common/setModalTitle', '');
};
</script>

<style scoped>
.custom-delete {
  margin-top: -5px;
}
</style>
